import Gardener from 'scoreboard/components/gardener'
import { Transform } from 'stream'
import iconForObject from 'scoreboard/components/icon-for-object'

const CustomIconGardener = Gardener.extend({
	_treeOptions: function() {
		var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)
		treeOptions.stream = treeOptions.stream.pipe(this._iconTransform())
		treeOptions.accessors = { icon: 'icon' }
		return treeOptions
	},

	_iconTransform: function() {
		let icons = new Transform({ objectMode: true })
		let self = this
		icons._transform = function (node, enc, next) {
			node.icon = self.getIcon(node)
			this.push(node)
			next()
		}
		return icons
	},

  /**
   * Returns the correct icon for a given node
   * @param {Object} node The tree node which is in need of an icon
   */
  getIcon(node) {
		return iconForObject(node)
	}
})

export default CustomIconGardener

CustomIconGardener.__filename__ = 'components/custom-icon-gardener.js'
